import React from 'react';
import { BellIcon, CheckIcon, ClockIcon, MessageSquareIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { CITY_SIGNATURE, DEMO_CITIZEN, type DemoMessage } from '../../data/brossardRequests';

/** Citizen ↔ City thread for the Brossard demo requests. */
export function DemoRequestMessages({
  messages
}: {
  messages: DemoMessage[];
}) {
  const {
    t,
    lang
  } = useLanguage();
  return <div className="space-y-5" data-id="element-5461" data-mp="3imx1yq5c2rii">
      <div className="flex items-center gap-2 text-xs text-slate-500 bg-slate-50 border border-slate-200 rounded-lg px-3 py-2" data-id="element-5462" data-mp="3illuogcoj1mn">
        <BellIcon className="w-3.5 h-3.5 text-slate-400 flex-shrink-0" data-id="element-5463" data-mp="3sdrkbjfgl6yo" />
        {t(`${DEMO_CITIZEN.name} reçoit chaque message par courriel et SMS.`, `${DEMO_CITIZEN.name} receives every message by email and SMS.`)}
      </div>

      {messages.length === 0 && <div className="text-center py-10" data-id="element-5464" data-mp="a7n0nk99pqbs">
          <span className="inline-flex w-10 h-10 items-center justify-center rounded-full bg-slate-100 text-slate-400 mb-3" data-id="element-5465" data-mp="a8g0e19t7fkf">
            <MessageSquareIcon className="w-5 h-5" data-id="element-5466" data-mp="14copkb1alyf2" />
          </span>
          <p className="text-sm font-medium text-slate-700" data-id="element-5467" data-mp="10ceeijyn8htc">{t('Aucun message', 'No messages')}</p>
          <p className="text-sm text-slate-500 mt-1" data-id="element-5468" data-mp="vew9v5rnsor5">
            {t('Écrivez à la citoyenne pour lui donner un suivi.', 'Write to the citizen to give them an update.')}
          </p>
        </div>}

      {messages.map((m, i) => {
      const showDay = i === 0 || messages[i - 1].day.fr !== m.day.fr;
      const fromCity = m.from === 'ville';
      return <React.Fragment key={i} data-id="element-5469" data-mp="1ec760hhzv22d" data-mpi={i}>
            {showDay && <div className="text-center" data-id="element-5470" data-mp="1eamd0wbbvr6m">
                <span className="text-[11px] font-semibold text-slate-400 uppercase tracking-wider" data-id="element-5471" data-mp="19cukq16ru31w">
                  {m.day[lang]}
                </span>
              </div>}
            <div className={`flex gap-3 ${fromCity ? 'flex-row-reverse' : ''}`} data-id="element-5472" data-mp="2229t0j71xhu4">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center text-[10px] font-bold flex-shrink-0 ${fromCity ? 'bg-slate-800 text-white' : 'bg-[#4F46E5] text-white'}`} data-id="element-5473" data-mp="59gm9aq1xil">
                {fromCity ? 'VB' : DEMO_CITIZEN.initials}
              </div>
              <div className="flex-1 min-w-0" data-id="element-5474" data-mp="3rids3wjnjg9a">
                <div className={`rounded-xl p-3.5 text-sm leading-relaxed ${fromCity ? 'bg-[#4F46E5] text-white rounded-tr-sm' : 'bg-slate-50 border border-slate-200 text-slate-700 rounded-tl-sm'}`} data-id="element-5475" data-mp="3cmebfxih87sj">
                  {m.text[lang]}
                </div>
                <div className={`text-[11px] text-slate-400 mt-1 flex items-center gap-1.5 flex-wrap ${fromCity ? 'justify-end' : ''}`} data-id="element-5476" data-mp="38l2s29q74iss">
                  {fromCity ? CITY_SIGNATURE : DEMO_CITIZEN.name} · {m.time[lang]}
                  {m.readAt && <span className="inline-flex items-center gap-1 text-emerald-600 font-medium" data-id="element-5477" data-mp="1byjtael38twh">
                      <CheckIcon className="w-3 h-3" data-id="element-5478" data-mp="1ppg7v1i6jakj" />
                      {m.readAt[lang]}
                    </span>}
                  {m.awaitingReply && <span className="inline-flex items-center gap-1 text-amber-600 font-medium" data-id="element-5479" data-mp="1kx58bzrcpqsi">
                      <ClockIcon className="w-3 h-3" data-id="element-5480" data-mp="1zpp7kpbdre4o" />
                      {t('En attente de réponse de la citoyenne', 'Waiting for the citizen’s reply')}
                    </span>}
                </div>
              </div>
            </div>
          </React.Fragment>;
    })}
    </div>;
}